export default "__VITE_ASSET__Oe2xfCxu__"